import React from 'react'
import { CustomLeftArrow, CustomRightArrow } from 'components/common/CustomArrows/CustomArrows'
import { useStyles } from './styles'
import { Show as ShowData } from 'data/Show'
import Show from 'components/root/Show/Show'
import Carousel from 'react-multi-carousel'

interface ShowsProps {
    items: ShowData[]
    title?: string
    className?: string
    onItemClick: (show: ShowData) => void
}

const Shows: React.FC<ShowsProps> = ({ items, title, className = '', onItemClick }) => {
    const classes = useStyles()

    const shows = items
        .reduce(
            (acc: ShowData[], v: ShowData) =>
                v.seriesId ? (!acc.find(({ seriesId }) => seriesId === v.seriesId) ? [...acc, v] : acc) : [...acc, v],
            [],
        )
        .map((show: ShowData) => ({
            ...show,
            times: show.seriesId ? items.filter(({ seriesId }) => seriesId === show.seriesId).length : 1,
        }))

    const responsive = {
        xl: {
            breakpoint: { max: 4000, min: 460 },
            items: 3,
            slidesToSlide: 3,
        },
        xs: {
            breakpoint: { max: 460, min: 0 },
            items: 1,
            slidesToSlide: 1,
            partialVisibilityGutter: shows.length > 1 ? 110 : 0,
        },
    }

    return (
        <section className={className}>
            {title && <h3 className={classes.sectionTitle}>{title}</h3>}
            <Carousel
                partialVisible
                responsive={responsive}
                showDots={false}
                containerClass={classes.container}
                customLeftArrow={<CustomLeftArrow onClick={() => {}} />}
                customRightArrow={<CustomRightArrow onClick={() => {}} />}
            >
                {shows.map(show => (
                    <Show times={show.times} onClick={onItemClick} key={show._id} show={show} />
                ))}
            </Carousel>
        </section>
    )
}

export default React.memo(Shows)
